import { CalculatorIcon, CompanyIcon, CreditCardIcon, LoanIcon, Text } from '@cash-me/react-components'

export const cards = [
  {
    id: 'modalities-01',
    title: 'Cartão de Crédito',
    icon: CreditCardIcon,
    content: () => (
      <>
        <Text color="var(--colors-neutral-text-weak)">
          Essa linha de crédito é muito comum no Brasil, mas não é a melhor opção disponível. Embora ofereça diversas
          vantagens, como clube de benefícios e 40 dias para pagamento, o cartão de crédito tem as taxas mais altas do
          mercado em caso de atraso na quitação da fatura, cerca de 14% ao mês em média.
        </Text>
      </>
    )
  },
  {
    id: 'modalities-02',
    title: 'Empréstimo Consignado',
    icon: CompanyIcon,
    content: () => (
      <>
        <Text color="var(--colors-neutral-text-weak)">
          Esse tipo de crédito se caracteriza por disponibilizar parcelas fixas e juros mais baixos, se comparado às
          outras modalidades, como o empréstimo pessoal, por exemplo. Nesse caso, a redução das tarifas é possível
          porque o empréstimo consignado oferece menor risco de inadimplência, já que o seu pagamento é feito a partir
          de descontos realizados na folha de pagamento, holerite, contracheque ou benefício do INSS. A contratação é
          rápida, simples e sem a necessidade de avalista ou fiador.
        </Text>
      </>
    )
  },
  {
    id: 'modalities-03',
    title: 'Empréstimo Pessoal',
    icon: LoanIcon,
    content: () => (
      <>
        <Text color="var(--colors-neutral-text-weak)">
          O empréstimo pessoal é uma das modalidades mais populares e simples de contratar. Porém, os juros embutidos
          nesse tipo de crédito são mais altos do que os de outras opções do mercado. As tarifas exorbitantes ocorrem
          porque esse financiamento oferece grande risco de inadimplência. Embora o crédito possa ser utilizado como o
          cliente desejar, ele é pouco seguro para a saúde da sua vida financeira, considerando o valor das tarifas, os
          prazos e as regras das instituições credoras.
        </Text>
      </>
    )
  },
  {
    id: 'modalities-04',
    title: 'Cheque Especial',
    icon: CalculatorIcon,
    content: () => (
      <>
        <Text color="var(--colors-neutral-text-weak)">
          O cheque especial atua como um crédito pré-aprovado na conta bancária do cliente, sem restrição de uso.
          Contudo, a taxa de juros altíssima dificulta o controle da sua vida financeira. Além disso, as taxas de juros
          para a utilização dessa linha de crédito podem chegar a mais de 300% ao ano.
        </Text>
      </>
    )
  }
]
